export const company = {
  name: "Travel Desire",
  website: "https://www.traveldesire.in",
  currency: "INR",
  contact_email: "sales@traveldesire.in",
  phone: "+91-XXXXXXXXXX",
};

export const packages = [
  // paste ALL package objects here
];
